import { AlertDialog, DialogContainer } from '@adobe/react-spectrum';
import React, { useState } from 'react';

import AutoLink from './AutoLink';
import HelpSupportGridListItem from './HelpSupportGridListItem';

const RedirectUrlToNewTab = ({ icon, label, url, loading, appType }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const ListItem = ({ onClick }) => (
    <HelpSupportGridListItem
      icon={icon}
      label={label}
      loading={loading}
      dataLaunchId={`Help and Support : ${label}`}
      onClick={onClick}
    />
  );

  const onClickUrl = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      {!loading && url
        ? label !== 'Terms of use' && <ListItem onClick={() => onClickUrl(url)} />
        : !loading &&
          label === 'Privacy policy' && (
            <>
              <ListItem onClick={() => setIsDialogOpen(true)} />
              <DialogContainer onDismiss={() => setIsDialogOpen(false)}>
                {isDialogOpen && (
                  <AlertDialog title={label} variant="information" primaryActionLabel="Close">
                    Adobe’s privacy policy is not applicable to the use of this app, extension or integration. Please
                    refer to the privacy policy provided by the developer or contact the developer directly for more
                    information about their privacy practices
                  </AlertDialog>
                )}
              </DialogContainer>
            </>
          )}

      {/* Terms of use for UXP is URL and for ZXP is Text */}

      {!loading && url && label === 'Terms of use' && appType === 'UXP' ? (
        <ListItem onClick={() => onClickUrl(url)} />
      ) : (
        !loading &&
        url &&
        label === 'Terms of use' &&
        appType === 'ZXP' && (
          <>
            <ListItem onClick={() => setIsDialogOpen(true)} />
            <DialogContainer onDismiss={() => setIsDialogOpen(false)}>
              {isDialogOpen && (
                <AlertDialog title={label} variant="information" primaryActionLabel="Close">
                  <AutoLink>{url}</AutoLink>
                </AlertDialog>
              )}
            </DialogContainer>
          </>
        )
      )}
    </>
  );
};

export default RedirectUrlToNewTab;
